import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Button, ButtonVariant, Text, TextColor, TextVariant, TextWeight } from "../../../components";
export const OrderSummary = t0 => {
  const $ = _c(25);
  const {
    cart,
    loadingCart,
    isFormValid,
    orderAction,
    loadingCreateOrder,
    idCarrier
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text text="Podsumowanie" variant={TextVariant.H6} weight={TextWeight.SEMIBOLD} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text text={"Cena produkt\xF3w"} weight={TextWeight.SEMIBOLD} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] !== cart.subtotals || $[3] !== loadingCart) {
    t3 = <div className="flex justify-between">{t2}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.products.value} />}</div>;
    t4 = cart.subtotals?.discounts && cart.subtotals.discounts.amount !== 0 && <div className="flex justify-between"><Text text="Rabat" weight={TextWeight.SEMIBOLD} />{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.discounts.value} color={TextColor.SPECIAL_700} weight={TextWeight.SEMIBOLD} className="bg-green-100" />}</div>;
    $[2] = cart.subtotals;
    $[3] = loadingCart;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text text={"Wysy\u0142ka"} weight={TextWeight.SEMIBOLD} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== cart.subtotals || $[8] !== idCarrier || $[9] !== loadingCart) {
    t6 = <div className="flex justify-between">{t5}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.subtotals.shipping.value ? `${cart.subtotals.shipping.value !== "Za darmo!" && idCarrier === null ? "od " : ""}${cart.subtotals.shipping.value}` : "od 0,00 z\u0142"} />}</div>;
    $[7] = cart.subtotals;
    $[8] = idCarrier;
    $[9] = loadingCart;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text text="Razem" weight={TextWeight.BOLD} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== cart.totals || $[13] !== loadingCart) {
    t8 = <div className="flex justify-between border-t pt-4 mt-4">{t7}{loadingCart ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={cart.totals.total.value} weight={TextWeight.BOLD} />}</div>;
    $[12] = cart.totals;
    $[13] = loadingCart;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = !isFormValid || loadingCreateOrder;
  let t10;
  if ($[15] !== loadingCreateOrder || $[16] !== orderAction || $[17] !== t9) {
    t10 = <Button text={"Zam\xF3wienie z obowi\u0105zkiem zap\u0142aty"} variant={ButtonVariant.PRIMARY} className="!w-full" disabled={t9} loading={loadingCreateOrder} onClick={orderAction} />;
    $[15] = loadingCreateOrder;
    $[16] = orderAction;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t4 || $[22] !== t6 || $[23] !== t8) {
    t11 = <>{t1}<div className="flex flex-col gap-4 mt-6">{t3}{t4}{t6}{t8}{t10}</div></>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};